<template>
    <div class="body">
        <div class="d-flex justify-content-center loader visibility-hidden" v-if="loader">
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="Client-post d-flex">
            <div v-for="post in posts" :key="post.id" class="client_panel d-flex flex-row ">
                <mdb-card wide>
                    <mdb-view hover cascade>
                        <a :href="post.lien_real">
                            <mdb-card-image :src="post.better_featured_image.source_url" :alt="post.better_featured_image.alt_text" ></mdb-card-image>
                        </a>
                    </mdb-view>
                    <mdb-card-body class="text-center pb-0" cascade>
                        <mdb-card-title><strong v-html="post.title.rendered"></strong></mdb-card-title>
                        <mdb-card-text class="post-content" v-html="post.content.rendered"></mdb-card-text>
                        <mdb-btn outline="primary"><a :href="post.lien_real" target="_blank">Voir le site</a></mdb-btn>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>
</template>

<script>
    import { mdbCard, mdbView, mdbCardImage, mdbCardTitle, mdbCardText, mdbCardBody, mdbBtn  } from 'mdbvue';
    export default {
        name: "Portfolio",
        components: {
            mdbCard,
            mdbView,
            mdbCardImage,
            mdbCardTitle,
            mdbCardText,
            mdbCardBody,
            mdbBtn
        },
        data() {
            return {
                posts: [],
                loader: true,
            }
        },
        created: function () {
            this.loader = true;
            this.$http.get('wp/v2/posts').then(response => {
                for (let post in response.data) {
                    this.posts.push(response.data[post]);
                }
                this.loader = false;
            }, error => {
                alert(error)
                this.loader = true;
            });
        }
    }
</script>

<style scoped>
    .loader {
        margin-top: 70%;
        margin-bottom: 110%;
    }

    .text-danger{
        color: #A52A2A !important;
    }

    a{
        color: #EAEAEA;
    }

    .body {
        padding-top: 10vh;
    }

    .Client-post {
        justify-content: space-around;
        flex-direction: column;
    }

    .card {
        margin: 25px 30px;
    }

    .view-cascade{
        margin-left: -10px;
        margin-right: -10px;
        border-radius: 5px;
    }

    .card-body{
        padding: 0 !important;
        background-color: #363636;
    }

    .card-title{
        padding-top: 1.25rem;
        color: #A52A2A;
    }

    .card-text{
        padding-left: 1.25rem;
        padding-right: 1.25rem;
        color: #EAEAEA !important;
    }

    .btn-outline-primary{
        border: 2px solid #EAEAEA !important;
        color: #EAEAEA !important;
        margin: 20px;
    }

    .post-content {
        font-size: 12px;
        text-align: justify;
        width: 100%;
        margin-bottom: 30px;
    }

    @media (min-width: 576px) {
        .loader {
            margin-top: 60%;
            margin-bottom: 90%;
        }

        .Client-post {
            justify-content: space-around;
        }

        .card {
            margin: 45px 50px;
        }

        .post-content {
            font-size: 16px;
        }
    }
    @media (min-width: 768px) {

        .loader {
            margin-top: 50%;
            margin-bottom: 50%;
        }

        .Client-post {
            justify-content: space-around;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .client_panel{
            width: 50%;
        }

        .card {
            margin: 45px 50px;
        }

        .post-content {

        }
    }
    @media (min-width: 992px) {
        .loader {
            margin-top: 35%;
            margin-bottom: 40%;
        }
        .card {
            margin: 65px 70px;
        }
    }
    @media (min-width: 1200px) {
        .loader {
            margin-top: 30%;
            margin-bottom: 25%;
        }
        .card {
            margin: 105px 110px;
        }
    }

    @media (min-width: 1600px) {
        .loader {
            margin-top: 20%;
            margin-bottom: 30%;
        }
        .card {
            margin: 150px 75px;
        }
    }

</style>